package learning.components


import antd.button.button
import antd.form.form
import antd.form.formItem
import antd.input.input
import antd.input.textArea
import antd.message.message
import com.jingfangpai.common.orm.mapping.Content
import com.jingfangpai.common.orm.mapping.enums.ContentType
import com.jingfangpai.content.model.ContentVo
import react.*
import react.dom.div
import community.containers.TopicEditPageContext
import external.ckEditor.CKEditor
import external.ckEditor.ClassicEditor
import external.ckEditor.EditorConf
import external.ckEditor.EditorToolbarConf
import kotlinext.js.Object
import kotlinext.js.jsObject
import kotlinx.browser.document
import learning.containers.TcmFaqEditPageContext
import react.dom.attrs
import react.dom.textarea
import react.router.dom.useHistory
import urlBase

external interface TcmFaqEditProps : RProps {
    var id:String
}

data class TcmFaqEditContextData(var placeHolderFunction: (param: String) -> Unit)

val TcmFaqEdit = functionalComponent<TcmFaqEditProps> { props ->

    val ctx = useContext(TcmFaqEditPageContext)
    val history = useHistory()
    val (topic,setTopic) = useState(ContentVo().apply {
        type = ContentType.TcmFaq
    })
    val (editor,setEditor) = useState<CKEditor?>(null)
    val (editorContentLoaded,setEditorContentLoaded) = useState(false)

    fun onContentChanged(event:dynamic,data:dynamic,editorInstance:CKEditor){
        setEditor(editorInstance)
    }

    fun onEditorInit(editor:CKEditor){
        console.log("onEditorInit",editor)
        setEditor(editor)

        editor.editing.view.change( {writer->
            writer.setStyle( "min-height", "400px", editor.editing.view.document.getRoot() );
        } );
        editor.model.document.on("change:data", {event,data->
            onContentChanged(event,data,editor)
        });
    }

    fun onSave(event: dynamic) {
        editor?.let {
            editor.getData().let{ data ->
                topic.content = data
            }
        }
        if(topic.title.isNullOrBlank()){
            message.error("请填写问题")
            return;
        }
        if(topic.content.isNullOrBlank()){
            message.error("请详述问题内容")
            return;
        }
        message.loading("正在保存")
        ctx.saveContent(topic,{ resp->
            if(resp.ok()){
                if(topic.id.isNullOrBlank()){ //新增
                    history.push(LearningRoute.TcmFaqEdit.link.url.replace(":id",resp.data?.id?:""))
                }else {
                    resp.data?.let { setTopic(it) }
                }
            }
        },{
            console.log(it)
            message.error("保存失败，${it.message}")
        })
    }

    useEffect(topic) {
        if(editor != null && topic.content != null && editor.getData().isNullOrBlank() && topic.content != editor.getData()){ //仅当编辑器内容为空时
            editor.setData(topic.content!!)
            setEditorContentLoaded(true)
        }
    }

    useEffect(editor){
        console.log("data",editor?.getData())
        if(editor != null && !editorContentLoaded && topic.content != null && topic.content != editor.getData()){
            editor.setData(topic.content!!)
            setEditorContentLoaded(true)
        }
    }

    useEffect(props.id) {
        if("new"!=props.id){
            if(props.id.length == 32) {
                ctx.getContent(ContentType.TcmFaq,props.id,{ resp->
                    if(resp.ok() && resp.data !=null){
                        setTopic(resp.data!!)
                    }else{
                        message.error("获取问题失败")
                    }
                },{
                    message.error("获取问题失败")
                })
            }
        }else{

        }
    }
    useEffectOnce {
        ClassicEditor.create(document.querySelector("#editor"), jsObject<EditorConf> {
            toolbar = jsObject <EditorToolbarConf> {
                items = arrayOf(
                    "|",
                    "bold",
                    "italic",
                    "underline",
                    "fontSize",
                    "fontColor",
                    "link",
                    "bulletedList",
                    "numberedList",
                    "|",
                    "outdent",
                    "indent",
                    "|",
                    "imageUpload",
                    "blockQuote",
                    "insertTable",
                    "undo",
                    "redo",
                    "horizontalLine"
                )
            }
            language = "zh-cn"
            licenseKey = ""
        }
        )
            .then(::onEditorInit)
            .catch { error ->
                console.error(error);
            }

    }

    div("TopicEdit") {
        form {
            attrs{
                layout = "horizontal"
            }
            formItem {
                attrs{
                    label = "问题"
                }
                input {
                    attrs {
                        value = topic.title ?:""
                        placeholder = "必填"
                        onChange = {event: dynamic ->
                            val _topic = Object.assign(ContentVo(),topic)
                            _topic.title = event.target.value as String
                            setTopic(_topic)
                        }
                    }
                }
            }

            formItem {
                attrs{
                    label = "问题详情"
                }
                div{
                    textarea{
                        attrs{
                            rows = "40"
                        }
                        attrs["id"] = "editor"
                    }
                }
            }
            formItem {
                attrs{
                    label = "排序位置"
                }
                input {
                    attrs {
                        type = "number"
                        value = topic.weight ?:1
                        placeholder = "请填写排序位置"
                        onChange = {event: dynamic ->
                            val _topic = Object.assign(ContentVo(),topic)
                            _topic.weight = (event.target.value as String).toInt()
                            setTopic(_topic)
                        }
                    }
                }
            }
            formItem {
                button {
                    attrs{
                        type = "primary"
                        onClick = ::onSave
                    }
                    +"提交"
                }
            }
        }
    }
}
